<template>
  <div class="exam-paper container">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/exam/list` }">在线题库</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/exam/detail/${this.$route.params.examId}` }">{{chapter.exam_name}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{chapter.name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">章节上线状态：</span>
            <el-switch v-model="chapter.status"
                       @change="handleUpdateChapterStatus"></el-switch>
          </div>
          <div class="tips">
            <p class="label">
              <i class="el-icon-warning-outline"></i>
              题目编辑为实时保存，建议编辑时先关闭对应章节的上线状态，避免影响用户操作
            </p>
          </div>
        </div>
        <div class="right">
          <el-button type="primary"
                     @click="handleToPreview">预览</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="title-wrap">
        <div class="input-box">
          <span>试卷名称：</span>
          <el-input v-model="paper.name"
                    placeholder="编辑试卷名称"
                    @change="handlePaperNameChange"></el-input>
          <el-tooltip class="item"
                      effect="dark"
                      content="在未自定义修改的情况下，试卷名称会默认跟随章节"
                      placement="top-start">
            <i class="el-icon-info"
               style="margin-left: 10px;"></i>
          </el-tooltip>

        </div>
        <div class="score">
          <span>总分值：{{conputendSocre}}分</span>
          <el-button type="primary"
                     @click="handleClickScore">分值管理</el-button>
        </div>
      </div>
      <div class="exam-wrap">
        <div class="exam-item"
             v-for="(item, $index) in pages[pageIndex]"
             :key="item.id">
          <Single v-if="item.answer_type === 0"
                  :title="`${computeIndex($index)+1} 单选题`"
                  :content="item"
                  @shuxin="shuaxin"
                  :itemList="itemList"
                  @save="handleExamSave($event, $index)">
            <div style="display: flex;align-items:center;">
              <div class="sort-wrap">
                移动到第
                <el-input-number v-model="item.count_index"
                                 :min="1"
                                 :max="itemList.length"
                                 @change="handleExamSortChange(computeIndex($index),item.count_index)"></el-input-number>
                题
              </div>
              <!--         <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div> -->
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Single>
          <Multiple v-if="item.answer_type === 1"
                    :title="`${computeIndex($index)+1} 多选题`"
                    :content="item"
                    :itemList="itemList"
                    @shuxin="shuaxin"
                    @save="handleExamSave($event, $index)">
            <div style="display: flex;align-items:center;">
              <div class="sort-wrap">
                移动到第
                <el-input-number v-model="item.count_index"
                                 :min="1"
                                 :max="itemList.length"
                                 @change="handleExamSortChange(computeIndex($index),item.count_index)"></el-input-number>
                题
              </div>
              <!--   <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div> -->
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Multiple>
          <Judge v-if="item.answer_type === 3"
                 :title="`${computeIndex($index)+1} 判断题`"
                 :content="item"
                 :itemList="itemList"
                 @shuxin="shuaxin"
                 @save="handleExamSave($event, $index)">
            <div style="display: flex;align-items:center;">
              <div class="sort-wrap">
                移动到第
                <el-input-number v-model="item.count_index"
                                 :min="1"
                                 :max="itemList.length"
                                 @change="handleExamSortChange(computeIndex($index),item.count_index)"></el-input-number>
                题
              </div>
              <!--    <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div> -->
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Judge>
          <Qa v-if="item.answer_type === 4"
              :title="`${computeIndex($index)+1} 自测题`"
              :content="item"
              :itemList="itemList"
              @shuxin="shuaxin"
              @save="handleExamSave($event, $index)">
            <div style="display: flex;align-items:center;">
              <div class="sort-wrap">
                移动到第
                <el-input-number v-model="item.count_index"
                                 :min="1"
                                 :max="itemList.length"
                                 @change="handleExamSortChange(computeIndex($index),item.count_index)"></el-input-number>
                题
              </div>
              <!--    <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div> -->
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Qa>
          <Material v-if="item.answer_type === 8"
                    :title="`${computeIndex($index)+1} 材料题`"
                    :content="item"
                    :itemLists="itemList"
                    @shuxin="shuaxin"
                    @save="handleExamSave($event, $index)">
            <div style="display: flex;align-items:center;">
              <div class="sort-wrap">
                移动到第
                <el-input-number v-model="item.count_index"
                                 :min="1"
                                 :max="itemList.length"
                                 @change="handleExamSortChange(computeIndex($index),item.count_index)"></el-input-number>
                题
              </div>
              <!--  <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div> -->
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Material>
          <Cloze v-if="item.answer_type === 9"
                 :title="`${computeIndex($index)+1} 完形填空`"
                 :content="item"
                 @save="handleExamSave($event, $index)">
            <div style="display: flex;align-items:center;">
              <div class="sort-wrap">
                移动到第
                <el-input-number v-model="item.count_index"
                                 :min="1"
                                 :max="itemList.length"
                                 @change="handleExamSortChange(computeIndex($index),item.count_index)"></el-input-number>
                题
              </div>
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Cloze>
        </div>
        <div class="exam-add"
             v-if="pageIndex === pages.length-1">
          <p>+添加题目</p>
          <div class="exam-buttons">
            <el-button type="primary"
                       @click="handleExamItemAdd(0)">单选题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(1)">多选题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(3)">判断题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(4)">问答题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(8)">材料题</el-button>
            <!--     <el-button
              type="primary"
              @click="handleExamItemAdd(9)"
            >完形填空</el-button> -->
            <el-button type="primary"
                       icon="el-icon-link"
                       @click="handleExamItemCopy">题目引用</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="pager">
      <div :class="{'page': true,'active': pageIndex === $index}"
           v-for="(item, $index) in pages"
           :key="$index"
           @click="handlePageChange($index)">
        {{$index+1}}
      </div>
    </div>
    <Score :visible="dialogVisible"
           :paperId="this.paper.id"
           @close="dialogVisible=false"></Score>
    <PaperItemChoose :visible="paperChooseVisible"
                     @submit="handlePaperChoose"
                     @close="paperChooseVisible=false"></PaperItemChoose>
  </div>
</template>

<script>
import Single from '@/components/exam/Single'
import Multiple from '@/components/exam/Multiple'
import Judge from '@/components/exam/Judge'
import Qa from '@/components/exam/Qa'
import Material from '@/components/exam/Material'
import Cloze from '@/components/exam/Cloze'
import Score from '@/components/dialog/Score'
import PaperItemChoose from '@/components/dialog/paper/PaperItemChoose'
import {
  examChapterOne,
  examPaperOne,
  examPaperUpdate,
  examChapterUpdate,
  examPaperItemList,
  examPaperItemCreate,
  examPaperItemUpdate,
  examPaperItemsUpdate,
  examPaperItemDestroy,
  examPaperItemUnlink,
  examPaperItemLink,
  KnowledgeDetail,
} from '@/api/exam'

export default {
  components: {
    Single,
    Multiple,
    Judge,
    Qa,
    Material,
    Score,
    PaperItemChoose,
    Cloze,
  },
  data() {
    return {
      singleEdit: false,
      editType: false,
      chapter: {},
      paper: {},
      itemList: [],
      pageIndex: 0,
      pages: [[]],
      dialogVisible: false,
      paperChooseVisible: false,
    }
  },
  computed: {
    conputendSocre() {
      let score = 0
      this.itemList.forEach((item, index) => {
        if (!item.children) {
          score += Number(item.score || 0)
        }
        if (item.children) {
          item.children.forEach((subItem) => {
            score += Number(subItem.score || 0)
          })
        }
      })
      return score
    },
  },
  created() {
    this.fetchExamChapterInfo()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    shuaxin() {
      this.$router.go(0)
    },
    getKnowledge() {
      let p = []
      this.itemList.map((k) => {
        if (k.ref_read_item_id != null) {
          p.push(k.ref_read_item_id)
        }
      })
      let data = {
        item_ids_str: p.join(','),
      }
      KnowledgeDetail(data).then((res) => {
        res.list.map((t) => {
          this.itemList.map((k) => {
            if (t.item_id == k.ref_read_item_id) {
              k.readName = t.name
            }
          })
        })
      })
    },
    // 题库基本信息
    fetchExamChapterInfo() {
      examChapterOne({ id: this.$route.params.chapterId }).then((res) => {
        if (res) {
          this.chapter = res
          this.chapter.status = this.chapter.status === 1 ? true : false
          this.fetchExamPaperInfo()
          this.fetchExamPaperItemList()
        }
      })
    },
    // 试卷基本信息
    fetchExamPaperInfo() {
      examPaperOne({ id: this.chapter.paper_id }).then((res) => {
        if (res) {
          this.paper = res
        }
      })
    },
    // 试卷题目列表
    fetchExamPaperItemList() {
      examPaperItemList({ paper_id: this.chapter.paper_id }).then((res) => {
        this.itemList = res.list || []

        const result = this.itemList.every(function (element) {
          return element.ref_read_item_id == null
        })
        if (result == false) {
          this.getKnowledge()
        }

        this.itemList.forEach((item, index) => {
          this.$set(item, 'count_index', Number(index + 1))
          if (item.options) {
            item.options.forEach((v) => {
              v.true_option = v.true_option === 1 ? true : false
            })
          }
          if (item.children) {
            item.children.forEach((subItem) => {
              if (subItem.options) {
                subItem.options.forEach((v) => {
                  v.true_option = v.true_option === 1 ? true : false
                })
              }
            })
          }
        })
        // 分组切割：避免性能问题
        this.itemListChunks()
      })
    },
    // 章节发布状态变更
    handleUpdateChapterStatus(value) {
      examChapterUpdate({ id: this.chapter.id, status: value ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节在线状态更新异常')
          console.log('error: ', error)
        })
    },
    // 试卷名称变更
    handlePaperNameChange(value) {
      examPaperUpdate({ id: this.paper.id, name: value })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('试卷名称更新异常')
          console.log('error: ', error)
        })
    },
    // 滚动到页面顶部
    scrollToTop() {
      document.querySelector('#content').scrollTop = 0
    },
    // 题目保存
    handleExamSave(event, index) {
      this.itemList[index].content = event
      if (event.itemList) {
        this.itemListChunks()
      }
    },
    // 题目排序
    handleExamSortChange(sort, e) {
      let old = this.itemList.splice(sort, 1)[0]
      this.itemList.splice(e - 1, 0, old)

      this.itemListChunks()
      const rows = this.itemList.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examPaperItemsUpdate(rows)
        .then((res) => {
          this.fetchExamPaperItemList()
        })
        .catch((error) => {
          this.$message.error('题目排序更新异常')
          console.log('error: ', error)
        })
    },
    // 题目删除
    handleExamRemove(index) {
      // 二次确认撤销
      this.$confirm(`删除操作无法找回，请谨慎操作。`, '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      })
        .then(() => {
          examPaperItemDestroy({ id: this.itemList[index].id }).then((res) => {
            this.itemList.splice(index, 1)
            this.itemListChunks()
          })
        })
        .catch(() => {})
    },
    // 题目添加
    handleExamItemAdd(type) {
      let itemValue = {
        paper_id: this.paper.id,
        answer_type: type,
        sort: this.itemList.length,
      }
      if (type === 8) {
        itemValue.material = 1
      }
      examPaperItemCreate(itemValue).then((res) => {
        if (res.options) {
          res.options.forEach((v) => {
            v.true_option = v.true_option === 1 ? true : false
          })
        }
        this.itemList.push(res)
        this.itemListChunks()
      })
    },
    // 题目批量添加
    handleExamItemCopy() {
      this.paperChooseVisible = true
    },
    // 题目批量添加提交
    handlePaperChoose(val) {
      if (val && val.selections && val.selections.length) {
        const items = val.selections.map((v) => ({
          id: v.item_id,
          answer_type: v.answer_type,
        }))
        examPaperItemLink({ items, paper_id: this.paper.id }).then((res) => {
          this.fetchExamPaperItemList()
        })
      }
    },
    // 预览
    handleToPreview() {
      // if (this.paper) {
      //   if (location.host.includes('admin.koudaikaoyan.com')) {
      //     window.open(`https://www.koudaikaoyan.com/exam/paper?source=paper&paperId=${this.paper.id}&name=${this.paper.name}`)
      //   } else {
      //     window.open(`http://test.koudaikaoyan.com/exam/paper?source=paper&paperId=${this.paper.id}&name=${this.paper.name}`)
      //   }
      // }
    },
    // 分页
    handlePageChange(index) {
      this.pageIndex = index
      this.scrollToTop()
    },
    // 索引值计算
    computeIndex(index) {
      const pages = this.pages
      const temps = pages.slice(0, this.pageIndex)
      const length = [].concat(...temps).length
      return length + index
    },
    // 题库列表分割
    itemListChunks() {
      // 20题左右一组
      const totalItems = this.itemList
      const pages = [[]]
      totalItems.forEach((item) => {
        let last = pages[pages.length - 1]
        let length = last.length
        // 材料题
        if (item.material) {
          length += item.children ? item.children.length : 1
        } else {
          length += 1
        }
        last.push(item)
        if (length >= 20) {
          pages.push([])
        }
      })
      this.pages = pages
    },
    handleClickScore() {
      this.dialogVisible = true
    },
  },
}
</script>

<style scoped lang="less">
.exam-paper {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title-wrap {
      display: flex;
      justify-content: space-between;
      .score {
        min-width: 200px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-right: 15px;
      }
    }
    .input-box {
      display: flex;
      align-items: center;
      flex: 1;

      .el-input {
        width: 320px;
      }
    }
    .exam-item {
      margin-top: 20px;
      .sort-wrap {
        width: 220px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 12px;
        margin-right: 16px;
      }
    }
    .exam-add {
      position: relative;
      color: #303133;
      background-color: #fff;
      border: 1px dashed #0091ff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      overflow: hidden;
      padding: 20px;
      margin-top: 20px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .exam-buttons {
        margin-top: 10px;

        /deep/ .el-button {
          padding: 10px 30px;
          margin: 0 20px;
        }
      }
    }
  }
  .pager {
    position: fixed;
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);

    .page {
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      color: #606266;
      background: rgb(198, 226, 255);
      border-radius: 50%;
      cursor: pointer;

      & + .page {
        margin-top: 5px;
      }

      &.active {
        color: #fff;
        background: #409eff;
        cursor: default;

        &:hover {
          color: #fff;
        }
      }
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>
